import { render, staticRenderFns } from "./EsamiLaboratorioList.vue?vue&type=template&id=3d486d28"
import script from "./EsamiLaboratorioList.vue?vue&type=script&lang=js"
export * from "./EsamiLaboratorioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports